import React from "react";
import { LANGS, useI18n } from "@/i18n/I18nProvider";

/** Seletor PT | EN (pílula). `size="lg"` para o menu móvel. */
export default function LanguageSwitch({ size = "sm", className = "" }) {
    const { lang, setLang, t } = useI18n();
    const pad = size === "lg" ? "px-3 py-1.5 text-[13px]" : "px-2.5 py-1 text-[11px]";

    return (
        <div
            role="group"
            aria-label={t("lang.label")}
            data-testid="language-switch"
            className={`inline-flex shrink-0 items-center rounded-full border border-white/10 bg-black/30 p-0.5 ${className}`}
        >
            {LANGS.map((code) => {
                const active = code === lang;
                return (
                    <button
                        key={code}
                        type="button"
                        onClick={() => setLang(code)}
                        aria-pressed={active}
                        data-testid={`language-switch-${code}`}
                        className={`rounded-full font-bold uppercase tracking-[0.12em] transition-colors ${pad} ${
                            active
                                ? "bg-zrs-gold text-zrs-black"
                                : "text-zrs-offwhite/70 hover:text-gold"
                        }`}
                    >
                        {code}
                    </button>
                );
            })}
        </div>
    );
}
